import { injectable } from "inversify";
import { IPageConfigurationProvider } from "PageNavigation/IPageConfigurationProvider";
import Alcohol from "Pages/Alcohol/Alcohol";
import Anchor from "PageNavigation/Anchor";
import Home from "Pages/Home/Home";
import Page from "PageNavigation/Page";
import React from 'react';
import ProductPricing from "Pages/ProductPricing/ProductPricing";

@injectable()
export default class PageConfigurationProvider implements IPageConfigurationProvider {
    public readonly pages: Page[] = [
        new Page(
            "accueil", "Accueil", <Home />, [
                new Anchor("accueil", "Accueil" ),
                new Anchor("evenements", "Événements"),
                new Anchor("services", "Services"),
                new Anchor("tarifs", "Tarifs"),
                new Anchor("notre-equipe", "Notre équipe"),
                new Anchor("nous-joindre", "Nous joindre")
            ]
        ),
        new Page("alcool", "Alcool", < Alcohol />, [] ),
        new Page("tarifs", "Tarifs", < ProductPricing />, [] )
    ];
}